import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "film",
  "use": "film-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"film\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" transform=\"translate(1 1)\"><rect width=\"20\" height=\"20\" rx=\"2.18\" /><path d=\"M5 0v20M15 0v20M0 10h20M0 5h5M0 15h5M15 15h5M15 5h5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol